import { type MCPServerInfo } from '../../types';

const PlaidServer: MCPServerInfo = {
  serverId: 'PLAID',
  name: 'Plaid',
  slug: 'plaid',
  description:
    "Access bank account data, transaction history, and financial information through Plaid's secure API. Verify account ownership, categorize spending, analyze financial patterns, and enable payment workflows while maintaining bank-level security and compliance.",
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://api.dashboard.plaid.com/mcp/',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default PlaidServer;
